import IMG1 from "./assets/Journal_img.png";
import IMG2 from "./assets/desktopview.PNG";
import IMG3 from "./assets/note app.PNG";
import IMG4 from "./assets/carslot.PNG";
import IMG5 from "./assets/Metabnb.PNG";
import IMG6 from "./assets/gymlens.PNG";
import IMG7 from "./assets/edusite.PNG";
import IMG8 from "./assets/zurisite.PNG";
import IMG9 from "./assets/foodx.PNG";
import IMG10 from "./assets/formvaildation.PNG";
import IMG11 from "./assets/domaintask.PNG";
import IMG12 from "./assets/tabletask.PNG";
import IMG13 from "./assets/admindasboard.PNG";
import IMG14 from "./assets/resume.PNG";
import IMG15 from "./assets/countdown.PNG";
import IMG16 from "./assets/AnimeMagicIMG.png";
import IMG17 from "./assets/Resumepro.png";
import IMG18 from "./assets/JoexProfile.png";
import cIMG3 from "./assets/callery.PNG";

export const data = [
  {
    id: 1,
    Image: IMG1,
    title: "Journal",
    github: "https://github.com/JoeTechx/journal",
    demo: "https://letjournal.vercel.app/",
  },
  {
    id: 2,
    Image: IMG2,
    title: "Threads",
    github: "https://github.com/JoeTechx/Threads",
    demo: "https://threadcom.vercel.app/",
  },
  {
    id: 3,
    Image: IMG3,
    title: "Note app",
    github: "https://github.com/JoeTechx/Note_app",
    demo: "https://jottingapp.netlify.app/",
  },
  {
    id: 4,
    Image: IMG4,
    title: "Carslot",
    github: "https://github.com/JoeTechx/carslot",
    demo: "https://joetechx.github.io/carslot/",
  },
  {
    id: 5,
    Image: IMG5,
    title: "Metabnb",
    github: "https://github.com/JoeTechx/metabnb",
    demo: "https://dribbble.com/shots/16955822-Maintaining-tasks-and-tracking-progress",
  },
  {
    id: 6,
    Image: IMG6,
    title: "Gymlens",
    github: "https://github.com/JoeTechx/gymlens",
    demo: "https://gymlens.netlify.app/",
  },
];
export const moreData = [
  {
    id: 1,
    Image: IMG1,
    title: "Journal",
    des: "Journal is the connected workspace where better, faster work happens.",
    github: "https://github.com/JoeTechx/journal",
    demo: "https://letjournal.vercel.app/",
  },
  {
    id: 2,
    Image: IMG16,
    title: "Anime Magic",
    des: "Explore The Diverse Realms of Anime Magic",
    github: "https://github.com/JoeTechx/animevault",
    demo: "https://animevaut.vercel.app/",
  },
  {
    id: 3,
    Image: IMG2,
    title: "Threads",
    des: "Threads Application is a social media app for making friends and to share what's threading around the world",
    github: "https://github.com/JoeTechx/Threads",
    demo: "https://threadcom.vercel.app/",
  },
  {
    id: 4,
    Image: IMG3,
    title: "Note app",
    des: "Note app is designed to be your go-to note-taking app, providing a seamless and intuitive experience.",
    github: "https://github.com/JoeTechx/Note_app",
    demo: "https://jottingapp.netlify.app/",
  },
  {
    id: 5,
    Image: cIMG3,
    title: "Callery",
    des: "A drag and drop gallery of cars",
    github: "https://github.com/JoeTechx/Note_app",
    demo: "https://jottingapp.netlify.app/",
  },
  {
    id: 6,
    Image: IMG4,
    title: "Carslot",
    des: "CarSlot: Your Personal Travel Companion Embark on a new journey with CarSlot, the app that simplifies your travel experience.",
    github: "https://github.com/JoeTechx/carslot",
    demo: "https://joetechx.github.io/carslot/",
  },
  {
    id: 7,
    Image: IMG5,
    title: "Metabnb",
    des: "Metabnb: Your Gateway to the Crypto Metaverse: Step into the future of finance with Metabnb, your all-in-one crypto companion",
    github: "https://github.com/JoeTechx/metabnb",
    demo: "https://dribbble.com/shots/16955822-Maintaining-tasks-and-tracking-progress",
  },
  {
    id: 8,
    Image: IMG6,
    title: "Gymlens",
    des: "Gymlens: Your Vision for Fitness: Unleash the full potential of your fitness journey with Gymlens, the app that transforms your workout experience",
    github: "https://github.com/JoeTechx/gymlens",
    demo: "https://gymlens.netlify.app/",
  },
  {
    id: 9,
    Image: IMG7,
    title: "Edusite",
    des: "Edusite: Elevate Your Educational Experience: Welcome to Edusite, where learning meets innovation. It is More than just a school app",
    github: "https://github.com/JoeTechx/Edusitex",
    demo: "https://joetechx.github.io/Edusitex/",
  },
  {
    id: 10,
    Image: IMG8,
    title: "Zuri | Learn, Build, Grow",
    des: "Zuri | Learn, Build, Grow: Your Path to Tech Mastery: Unlock your full potential in the world of technology with Zuri, the ultimate platform for aspiring developers",
    github: "https://github.com/JoeTechx/Repli-Zuri",
    demo: "https://joetechx.github.io/Repli-Zuri/",
  },
  {
    id: 11,
    Image: IMG9,
    title: "FooDx",
    des: "FooDx: Elevate Your Culinary Experience Indulge your taste buds and embark on a culinary journey with FooDx, the ultimate food app designed for enthusiasts and connoisseurs alike.",
    github: "https://github.com/JoeTechx/Repli-Zuri",
    demo: "https://joetechx.github.io/FooDX/",
  },
  {
    id: 12,
    Image: IMG10,
    title: "Form validation",
    des: "FormGuard: Effortless Form Validation. No Errors, Just Progress. FormCheck simplifies the validation process, ensuring seamless data submissions with precision.",
    github: "https://github.com/JoeTechx/form-validation",
    demo: "https://joetechx.github.io/form-validation/",
  },
  {
    id: 13,
    Image: IMG11,
    title: "Domain task",
    des: "A domain task that takes about myself, my hobbies, my priorities, and my skills (zuri internship task) ",
    github: "https://github.com/JoeTechx/mydomain-task",
    demo: "https://joetechx.github.io/mydomain-task/",
  },
  {
    id: 14,
    Image: IMG12,
    title: "Table task",
    des: "A table that shows the scores of students in their exam and the total scores also (zuri internship task)",
    github: "https://github.com/JoeTechx/table-task",
    demo: "https://joetechx.github.io/table-task/",
  },
  {
    id: 15,
    Image: IMG17,
    title: "Resume",
    des: "My second resume full with HTML, Java script, swiper-bundle.js, CSS, and swiper-bundle.css but mainly full with swiper-bundle.min.js, swiper-bundle.css and java script",
    github: "https://github.com/JoeTechx/Joe_x",
    demo: "https://joetechx.github.io/Joe_x/",
  },
  {
    id: 16,
    Image: IMG13,
    title: "Admin dashboard",
    des: "AdminFlow: Streamlined Control, Insightful Metrics. Elevate Your Management with a Click.",
    github: "https://github.com/JoeTechx/Admin-broad",
    demo: "https://joetechx.github.io/Admin-broad/",
  },
  {
    id: 17,
    Image: IMG14,
    title: "Resume",
    des: "ProResume: Craft Your Success Story. Stand Out with a Professional Resume Tailored to Your Journey.",
    github: "https://github.com/JoeTechx/RESUME",
    demo: "https://joetechx.github.io/RESUME/",
  },
  {
    id: 18,
    Image: IMG15,
    title: "Countdown",
    des: "CountdownX: Time Unleashed. Create Anticipation with CountdownX - Your Ultimate Countdown Companion.",
    github: "https://github.com/JoeTechx/countdown",
    demo: "https://joetechx.github.io/countdown/",
  },
  {
    id: 19,
    Image: IMG18,
    title: "JoexProfile",
    des: "A Profile page of JoeX where you can see the current day, time, My Skills, Github Link",
    github: "https://github.com/JoeTechx/joexprofile",
    demo: "https://joetechx.github.io/joexprofile/",
  },
];
export const portfolioCard = [
  {
    id: 1,
    Image: IMG1,
    title: "Journal",
    des: "Journal is the connected workspace where better, faster work happens.",
    viewMore: "/portfolio",
  },
  {
    id: 2,
    Image: IMG11,
    title: "Domain task",
    des: "A domain task that takes about myself, my hobbies, my priorities, and my skills (zuri internship task) ",
    viewMore: "/portfolio",
  },
  {
    id: 3,
    Image: IMG13,
    title: "Admin dashboard",
    des: "AdminFlow: Streamlined Control, Insightful Metrics. Elevate Your Management with a Click.",
    viewMore: "/portfolio",
  },
  {
    id: 4,
    Image: IMG3,
    title: "Note app",
    des: "Note app is designed to be your go-to note-taking app, providing a seamless and intuitive experience.",
    viewMore: "/portfolio",
  },
];
